import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Bugs = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">⚙️ Bugs</h1>
          <p className="text-muted-foreground">Backlog, priority list, open vs closed</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Bugs Dashboard</CardTitle>
            <CardDescription>Backlog, priority list, open vs closed</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Bugs content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Bugs;